import { Button } from 'primereact/button';
import uploadIcon from '../../images/leftBar/upload.png';
import discoverIcon from '../../images/leftBar/globe.svg';
import calendarIcon from '../../images/leftBar/calendar.svg';
import diamondIcon from '../../images/leftBar/diamond.svg';
import microphoneIcon from '../../images/leftBar/microphone.png';
import picklistIcon from '../../images/leftBar/picklist.png';
import paddleIcon from '../../images/leftBar/paddle.png';
import gearIcon from '../../images/leftBar/gear.svg';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import '../LeftBar/index.scss';

export default function SkNavBar({switchSection}) {
    const { t } = useTranslation("common");
    return (
        <aside className="min-w-[50px] min-h-[330px] h-[calc(100vh-8rem)] content-center">
            <div className="min-h-[330px] flex flex-col items-center justify-center space-y-8">
                <Button className="navButton" onClick={ () => switchSection( "upload" ) }
                        tooltip={ t("sidebar.navBar.upload") }
                        aria-label={ t("sidebar.navBar.upload") }>
                    <img className="navIcon" src={uploadIcon}></img>
                </Button>
                <Button className="navButton" onClick={ () => switchSection( "home" ) }
                    tooltip={ t("sidebar.navBar.discover") }
                    aria-label={ t("sidebar.navBar.discover") }>
                    <img className="navIcon" src={discoverIcon}></img>
                </Button>
                <Button className="navButton" onClick={ () => switchSection( "studio" ) }
                        tooltip={ t("sidebar.navBar.studio") }
                    // https://siki.atlassian.net/browse/SK-398
                        tooltipOptions={{ className: 'buttonTooltip' }}
                        aria-label={ t("sidebar.navBar.studio") }>
                    <img className="navIcon" src={microphoneIcon}></img>
                </Button>
                <Button className="navButton" onClick={ () => switchSection( "calendar" ) }
                        tooltip={ t("sidebar.navBar.calendar") }
                        aria-label={ t("sidebar.navBar.calendar") }>
                    <img className="navIcon" src={calendarIcon}></img>
                </Button>
                <Button className="navButton" onClick={ () => switchSection( "collection" ) }
                        tooltip={ t("sidebar.navBar.collection") }
                        aria-label={ t("sidebar.navBar.collection") }>
                    <img className="navIcon" src={diamondIcon}></img>
                </Button>
                <Button className="navButton" onClick={ () => switchSection( "auction" ) }
                        tooltip={ t("sidebar.navBar.auction") }
                        aria-label={ t("sidebar.navBar.auction") }>
                    <img className="navIcon" src={paddleIcon}></img>
                </Button>
                <Button className="navButton" onClick={ () => switchSection( "settings" ) }
                        tooltip={ t("sidebar.navBar.settings") }
                        aria-label={ t("sidebar.navBar.settings") }>
                    <img className="navIcon" src={gearIcon}></img>
                </Button>
            </div>
        </aside>
    );
}